import React from 'react';

function firstChild(props) {
  var childrenArray = React.Children.toArray(props.children);
  return childrenArray[0] || null;
}

export { firstChild };


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/libs/utils/react.js
// module id = 325
// module chunks = 0